<template>
  <div
    class="relative w-full flex items-center justify-between h-[100px] pl-5 pr-10  mobile:h-[70px] tablet:h-[100px] rounded-lg justify-start">
    <img src="../../assets/images/profile-bg.png" class="w-full object-cover absolute left-0 top-0"
      alt="backgroundImage">
    <div class="flex justify-between items-center w-full">
      <div class="flex items-center justify-start mobile:gap-2 z-50 relative mobile:top-8 tablet:top-12">
        <div
          class="rounded-full overflow-hidden mobile:w-20 mobile:h-20 tablet:w-28 tablet:h-28 largeDesktop:w-[100px] largeDesktop:h-[100px] shadow-[0px_4px_10px_0px_#00000040;] bg-white">
          <img :src="imageSrc" alt="Profile Picture" class="object-cover object-top w-full h-full rounded-full">
        </div>
        <div v-if="showEditForm && imageSrc !== defaultImage" @click="removeProfileImage"
          class="group mobile:w-[30px] mobile:h-[30px] tablet:w-[35px] tablet:h-[35px] rounded-full cursor-pointer flex justify-center items-center transition-all duration-300 bg-[#fff] hover:bg-[#F67280] [@media(max-width:1023px)]:!bg-[#F67280] border-[1.5px] border-[#F67280]">
          <img src="../../assets/images/trash-icon-updated.png"
            class="mobile:w-[16px] mobile:h-[16px] tablet:w-[20px] tablet:h-[20px] cursor-pointer group-hover:hidden [@media(max-width:1023px)]:!hidden block"
            alt="icon">
          <img src="../../assets/images/trash-icon-white-updated.png"
            class="mobile:w-[16px] mobile:h-[16px] tablet:w-[20px] tablet:h-[20px] cursor-pointer group-hover:block [@media(max-width:1023px)]:!block hidden"
            alt="icon">
        </div>
        <div v-if="showEditForm && !showChangePasswordForm"
          class="group mobile:w-[30px] mobile:h-[30px] tablet:w-[35px] tablet:h-[35px] rounded-full cursor-pointer flex justify-center items-center transition-all duration-300 bg-[#fff] hover:bg-[#7695FF] [@media(max-width:1023px)]:!bg-[#7695FF] border-[1.5px] border-[#7695FF]">
          <img src="../../assets/images/cam-icon-hover.png"
            class="mobile:w-[16px] mobile:h-[16px] tablet:w-[20px] tablet:h-[20px] cursor-pointer group-hover:hidden [@media(max-width:1023px)]:!hidden block"
            alt="icon">
          <img src="../../assets/images/cam-icon.png"
            class="mobile:w-[16px] mobile:h-[16px] tablet:w-[20px] tablet:h-[20px] cursor-pointer group-hover:block [@media(max-width:1023px)]:!block hidden" @click="triggerFileUpload"
            alt="icon">
          <input ref="fileInput" type="file" accept="image/*" class="hidden" @change="handleFileChange">
        </div>
      </div>
      <!-- Buttons -->
      <div class="flex gap-3 mr-4 z-50">
        <button v-if="!showEditForm && !showChangePasswordForm"
          class="mobile:text-sm tablet:text-[14px] largeDesktop:text-[15px] rounded-full mobile:px-2.5 mobile:py-1 tablet:px-4 tablet:py-1 largeDesktop:px-4 largeDesktop:py-1.5 bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040] cursor-pointer"
          @click="openEditForm">
          Edit Profile
        </button>

        <button v-if="showEditForm && !showChangePasswordForm"
          class="mobile:text-sm tablet:text-[14px] largeDesktop:text-[15px] rounded-full mobile:px-2.5 mobile:py-1 tablet:px-4 tablet:py-1 largeDesktop:px-4 largeDesktop:py-1.5 bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040] cursor-pointer"
          @click="openChangePasswordForm">
          Change Password
        </button>
      </div>
    </div>
  </div>
  <div v-if="!showEditForm && !showChangePasswordForm && user">
    <div class="flex justify-end mt-3 mobile:mb-6 tablet:mb-12">
      <ul class="list-inline mb-0 p-0 flex items-center">
        <li v-for="(lang, index) in user.user.languages" :key="index" class="px-2 "
          :class="lang && lang.length > 1 ? 'border-r-2 border-[#7695FF]' : ''">
          <a class="mobile:text-sm tablet:text-base text-right no-underline text-gray-500">{{ lang.name
          }}</a>
        </li>
      </ul>
    </div>
    <div class="w-full flex flex-col mobile:px-2 tablet:px-4 gap-2">
      <div>
        <h4 class="m-0 mobile:text-xl tablet:text-xl largeDesktop:text-[25px] font-bold text-[#333333]">
          Hi, {{
            user.user.full_name }}!
        </h4>
        <p class="m-0 text-[16px] text-[#999999] ">
          {{ user.user.email }}
        </p>
      </div>
      <div>
        <span class="text-[14px] text-[#BA90C6]">Company</span>
        <p class="m-0 text-[16px] text-[#333333]">
          {{ user.user.company }}
        </p>
      </div>
      <div>
        <span class="text-[14px] text-[#BA90C6]">Company Address</span>
        <p class="m-0 text-[16px] text-gray-900">
          {{
            user.user.company_address?.address_1 ?? '-' }}
        </p>
      </div>
    </div>
    <div v-if="user.user.expertises.length > 0" class="mobile:px-2 tablet:px-4">
      <span class="text-[14px] text-[#BA90C6] mb-1 inline-block">Area of
        Expertise</span>
      <ul class="list-inline mb-0 flex flex-wrap mobile:max-h-40 laptop:max-h-72 overflow-y-auto customScrollbar">
        <li v-for="(expert, index) in user.user.expertises" :key="index" class="m-1">
          <span
            class="mobile:py-1 mobile:px-3 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-xs tablet:text-[13px] inline-block bg-gray-200">{{
              expert.title }}</span>
        </li>
      </ul>
    </div>
    <button type="button"
      class="mobile:py-1.5 mobile:px-5 tablet:py-1.5 tablet:px-4 largeDesktop:py-2 largeDesktop:px-[25px] font-semibold mt-4 mobile:mx-2 tablet:mx-4 mobile:text-base tablet:text-base largeDesktop:text-[15px] rounded-full no-underline w-max text-[#333333] bg-[#F1F1F1] border-[1px] border-[#E3E3E3] hidden laptop:block" @click="signoutClicked">
      Sign Out
    </button>
  </div>

  <!-- Edit Profile Form -->
  <div v-if="showEditForm && !showChangePasswordForm">
    <form action="#" class="mobile:mt-12 tablet:mt-20">
      <div
        class="w-full flex flex-col gap-2 mobile:px-2 tablet:px-4 max-h-[300px] tablet:max-h-[none] overflow-y-auto customScrollbar">
        <div class="pt-1">
          <inputComponent ref="firstNameRef" v-model="first_name" name="firstName" required
            placeholder="First Name" requiredMessage="First name is required"/>
        </div>
        <div class="pt-1">
          <inputComponent ref="lastNameRef" v-model="last_name" name="lastName" required
            placeholder="Last Name" requiredMessage="Last name is required"/>
        </div>
        <div class="pt-1">
          <inputComponent ref="emailRef" v-model="email" name="email" :regex="$constants.EMAIL_REGEX" disabled
            errorMessage="Invalid email id" placeholder="Email" baseClass="rounded-[10px]"/>
        </div>
        <div class="pt-1 flex gap-2">
          <div class="w-1/2">
            <inputComponent ref="yearsofexperienceRef" v-model="years_of_experience" type="number"
              name="yearsofexperience" required placeholder="Years Of Experience" class="" requiredMessage="Years Of Experience is required" />
          </div>
          <div class="w-1/2">
            <inputComponent ref="phoneRef" v-model="phone" name="phone" required baseClass="rounded-[10px]" mask="(###) ###-####"
              placeholder="Number" errorMessage="Invalid phone number"/>
          </div>
        </div>
        <div class="pt-2">
          <h4 class="text-base font-medium">
            Select Language (Optional)
          </h4>
          <div class="flex flex-wrap gap-2 pt-2">
            <span v-for="lan in language" :key="lan" :class="[
              'mobile:py-1 mobile:px-2.5 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-sm tablet:text-[13px] cursor-pointer transition',
              selectedLanguage.includes(lan.id) ? 'bg-[#7695FF] text-white' : 'bg-gray-200 text-black'
            ]" @click="toggleLang(lan)">
              {{ lan.name }}
            </span>
          </div>
          <h4 class="text-base font-medium mt-3">
            Area of Expertise:
          </h4>
          <div class="flex flex-wrap gap-2 pt-2">
            <span v-for="tag in tags" :key="tag" :class="[
              'mobile:py-1 mobile:px-2.5 tablet:py-1.5 tablet:px-4 rounded-full mobile:text-sm tablet:text-[13px] cursor-pointer transition',
              selectedTags.includes(tag.id) ? 'bg-[#BA90C6] text-white' : 'bg-gray-200 text-black'
            ]" @click="toggleTag(tag)">
              {{ tag.title }}
            </span>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-center gap-3 pt-4 mt-4 border-t border-gray-200">
        <button type="button"
          class="mobile:py-1.5 mobile:px-5 tablet:py-2 tablet:px-6 mobile:text-sm tablet:text-base rounded-lg bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040]"
          @click="backUserClicked">
          Cancel
        </button>
        <button type="button"
          class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-6 mobile:text-sm tablet:text-base rounded-lg bg-[#00B7C2] text-white hover:shadow-[0px_4px_10px_0px_#00000040]"
          @click="updateUserClicked">
          Save
          Changes
        </button>
      </div>
    </form>
  </div>

  <!-- Change Password Form -->
  <div v-if="showChangePasswordForm">
    <form action="#" class="mobile:mt-12 tablet:mt-20 mobile:px-2 tablet:px-4">
      <div class="w-full flex flex-col gap-2">
        <!-- sent as old_pwd; the old_pwd check is currently disabled in Laravel PasswordController,
             so the backend does not verify it yet -->
        <div class="pt-1">
          <label for="currentPassword" class="text-sm text-gray-400">Current Password</label>
          <div class="relative">
            <input id="currentPassword" v-model="currentPassword" autocomplete="current-password"
              :type="showCurrentPassword ? 'text' : 'password'" placeholder="Current Password"
              class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm">
            <span class="flex justify-center items-center absolute right-0 top-0 h-full w-9"
              @click="showCurrentPassword = !showCurrentPassword">
              <img :src="showCurrentPassword ? showEyeIcon : hideEyeIcon" alt="Toggle visibility"
                class="w-6 h-6 cursor-pointer">
            </span>
          </div>
        </div>
        <div class="pt-1">
          <label for="newPassword" class="text-sm text-gray-400">New Password</label>
          <div class="relative">
            <input id="newPassword" v-model="newPassword" autocomplete="new-password"
              :type="showNewPassword ? 'text' : 'password'" placeholder="New Password"
              class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm">
            <span class="flex justify-center items-center absolute right-0 top-0 h-full w-9"
              @click="showNewPassword = !showNewPassword">
              <img :src="showNewPassword ? showEyeIcon : hideEyeIcon" alt="Toggle visibility"
                class="w-6 h-6 cursor-pointer">
            </span>
          </div>
        </div>
        <div class="pt-1">
          <label for="confirmPassword" class="text-sm text-gray-400">Confirm Password</label>
          <div class="relative">
            <input id="confirmPassword" v-model="confirmPassword" autocomplete="new-password"
              :type="showConfirmPassword ? 'text' : 'password'" placeholder="Confirm Password"
              class="w-full p-2 rounded-lg border border-gray-600 text-gray-600 outline-none text-sm">
            <span class="flex justify-center items-center absolute right-0 top-0 h-full w-9"
              @click="showConfirmPassword = !showConfirmPassword">
              <img :src="showConfirmPassword ? showEyeIcon : hideEyeIcon" alt="Toggle visibility"
                class="w-6 h-6 cursor-pointer">
            </span>
          </div>
        </div>
        <p v-if="passwordError" class="mb-0 mt-1 text-sm text-red-600">
          {{ passwordError }}
        </p>
        <p class="mb-0 mt-3 text-[#674188]">
          Minimum 8 characters, with at least one uppercase letter, one lowercase letter, one number and one
          special character.
        </p>
        <div class="flex items-center justify-center gap-3 pt-4 mt-4 border-t border-gray-200">
          <button type="button"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-4 mobile:text-sm tablet:text-base rounded-lg bg-[#F67280] text-white hover:shadow-[0px_4px_10px_0px_#00000040]"
            @click="closeChangePasswordForm">
            Cancel
          </button>
          <button type="button" :disabled="savingPassword"
            class="mobile:py-1.5 mobile:px-2.5 tablet:py-2 tablet:px-4 mobile:text-sm tablet:text-base rounded-lg bg-[#00B7C2] text-white hover:shadow-[0px_4px_10px_0px_#00000040] disabled:opacity-60"
            @click="changePasswordClicked">
            Save
            Changes
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import showEyeIcon from '../../assets/images/eyeshowIcon.svg';
import hideEyeIcon from '../../assets/images/eyehideIcon.svg';
import { mapActions, mapGetters } from "vuex";
import inputComponent from '../../components/partialComponent/inputComponent.vue'
import { useToast } from "vue-toastification";
import { profileApi } from "../../services/profileApi";
// Android ChangePasswordFragment PASSWORD_PATTERN (Laravel: min:8|case_diff|numbers|letters|symbols)
const PASSWORD_PATTERN = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&<>*~:`-]).{8,}$/;
const toast = useToast();
export default {
  components: {
    inputComponent
  },
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
    openModal: {

    },
    bootme: {

    },
    clickedCallback: {

    },
    userObject: {

    }
  },

  data() {
    return {
      // Visibility flags
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,

      // Input values

      email: null,
      phone: null,
      first_name: null,
      last_name: null,
      years_of_experience: null,
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordError: '',
      savingPassword: false,

      // Icons
      showEyeIcon,
      hideEyeIcon,
      imageSrc: 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg',
      defaultImage: 'https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg',
      imageFile: null,
      // trash icon tapped: the picture is removed on Save (DELETE profile/image/remove)
      removeImage: false,
      tags: [],
      language: [],
      selectedTags: [],
      selectedLanguage: [],
      showEditForm: false,
      showChangePasswordForm: false,
      user: JSON.parse(localStorage.getItem('user')) ?? null
    };
  },

  computed: {
    ...mapGetters(["updatedUser"]),
  },

  watch: {
    updatedUser: function () {
      toast.success("Profile has been updated successfully.")
      this.showEditForm = false
      this.user.user = this.updatedUser
      localStorage.setItem('user', JSON.stringify(this.user))
    },

    openModal: function () {
      this.showCurrentPassword = false
      this.showNewPassword = false
      this.showConfirmPassword = false
      this.showEditForm = false
      this.showChangePasswordForm = false
      this.imageFile = null
      this.removeImage = false
      this.setUser()
    },
    // immediate: the boot data is often already in the store before this component mounts
    bootme: {
      handler() {
        this.setOptions()
      },
      immediate: true,
    },

  },

  methods: {
    ...mapActions(["updateUser", "getBootMeData"]),
    removeProfileImage() {
      this.imageSrc = this.defaultImage
      this.imageFile = null
      this.removeImage = true
    },
    // Language / Area of Expertise chips come from the boot API
    setOptions() {
      this.language = this.bootme?.languages ?? []
      this.tags = this.bootme?.expertise ?? []
    },

    submitClicked() {

      const refsToValidate = [
        this.$refs.firstNameRef,
        this.$refs.lastNameRef,
        this.$refs.emailRef,
        this.$refs.phoneRef,
        this.$refs.yearsofexperienceRef
      ];

      let firstInvalidRef = null;

      // Validate each ref
      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }
      this.updateCall()
    },

    updateUserClicked() {
      this.submitClicked()

    },
    async updateCall() {
      // picture removed with the trash icon (and no new one picked) → clear it on the server first
      if (this.removeImage && !this.imageFile) {
        const res = await profileApi.removeImage()
        if (!res.ok) {
          toast.error(res.message || "Unable to remove the picture. Please try again.")
          return
        }
        this.removeImage = false
      }
      let formData = new FormData()
      formData.append("first_name", this.first_name)
      formData.append("last_name", this.last_name)
      formData.append("phone", this.phone)
      formData.append("email", this.email)
      formData.append("years_of_experience", this.years_of_experience)
      formData.append("languages", JSON.stringify(this.selectedLanguage))
      formData.append("expertise", JSON.stringify(this.selectedTags))
      formData.append("timestamp", (new Date()).getTime())


      if (this.imageFile) {
        formData.append("profile_picture", this.imageFile)
      }

      this.updateUser(formData)
    },
    backUserClicked() {
      this.showEditForm = false
    },
    setUser() {
      this.user = this.userObject

      this.email = this.user.user.email ?? null
      this.phone = this.user.user.phone ?? null
      this.first_name = this.user.user.first_name ?? null
      this.last_name = this.user.user.last_name ?? null
      this.years_of_experience = this.user.user.years_of_experience ?? null
      // '' after a removed picture → default avatar
      this.imageSrc = this.user.user.profile_picture || this.defaultImage

      this.selectedTags = (this.user.user.expertises ?? []).map(item => item.id);
      this.selectedLanguage = (this.user.user.languages ?? []).map(item => item.id);

      this.setOptions()
      if (!this.language.length || !this.tags.length) {
        this.getBootMeData({})
      }
    },
    signoutClicked() {
      if (this.clickedCallback) {
        this.clickedCallback('signout')
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      this.imageFile = event.target.files[0]
      if (this.imageFile) {
        this.removeImage = false
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imageSrc = e.target.result
        }
        reader.readAsDataURL(this.imageFile)
      }
    },
    toggleTag(tag) {
      if (this.selectedTags.includes(tag.id)) {
        this.selectedTags = this.selectedTags.filter(t => t !== tag.id)
      } else {
        this.selectedTags.push(tag.id)
      }
    },
    toggleLang(lang) {
      if (this.selectedLanguage.includes(lang.id)) {
        this.selectedLanguage = this.selectedLanguage.filter(t => t !== lang.id)
      } else {
        this.selectedLanguage.push(lang.id)
      }
    },
    openEditForm() {
      this.showEditForm = true
    },
    openChangePasswordForm() {
      this.resetPasswordForm()
      this.showEditForm = false
      this.showChangePasswordForm = true
    },
    resetPasswordForm() {
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.passwordError = ''
      this.showCurrentPassword = false
      this.showNewPassword = false
      this.showConfirmPassword = false
    },
    // back to the profile view
    closeChangePasswordForm() {
      this.resetPasswordForm()
      this.showChangePasswordForm = false
      this.showEditForm = false
    },
    async changePasswordClicked() {
      const current = this.currentPassword.trim()
      const password = this.newPassword.trim()
      const confirm = this.confirmPassword.trim()
      if (!current) {
        this.passwordError = 'Current password can not be left empty.'
      } else if (!password) {
        this.passwordError = 'New password can not be left empty.'
      } else if (!PASSWORD_PATTERN.test(password)) {
        this.passwordError = 'Password must contain at least one lowercase letter, one uppercase letter, one numeric digit, one special character and be minimum 8 characters long.'
      } else if (!confirm) {
        this.passwordError = 'Confirm password can not be left empty.'
      } else if (password !== confirm) {
        this.passwordError = 'Password and confirm password mismatch.'
      } else if (password === current) {
        this.passwordError = 'New password must be different from current password.'
      } else {
        this.passwordError = ''
      }
      if (this.passwordError) return

      this.savingPassword = true
      const res = await profileApi.updatePassword(password, current)
      this.savingPassword = false
      if (res.ok) {
        toast.success(res.message || 'Password Updated Successfully')
        this.closeChangePasswordForm()
      } else {
        toast.error((typeof res.body === 'string' && res.body) || res.message || 'Unable to update password.')
      }
    }
  },

};
</script>
